module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-44.b90f481.woff2";